import clickOutside from './clickOutside';

const install = function (Vue) {
  Vue.directive('clickOutside', clickOutside);
};

export default install;
